import React from 'react';
import { useSelector } from 'react-redux';
import MarqueeContainer from 'ugc/components/ugcGallery/marquee/MarqueeContainer';
import useGetGalleryMediaList from 'ugc/hooks/useGetGalleryMediaList';
import Loading from 'client/components/Loading';
import { useHeightResizePostMessage } from 'client/hooks/useHeightResizePostMessage';

export default function WrapperMarquee({ data }) {
    const { promoIdOfUgcLink: promoId, uuid: promoUUID } = useSelector(s => s.promo);
    const buttonClickLink = `/ugc/${promoId}${window.location.search}${window.location.hash}`;
    const clientBodyRef = useHeightResizePostMessage({ useMaxSize: true });
    const { galleryMediaList, isInit } = useGetGalleryMediaList(promoUUID);
    const marquee = transformMarquee(galleryMediaList);

    function transformMarquee(mediaList) {
        // 如果一行不足 10 個作品 要塞假料
        const autoFillFakeMedia = (data, maxCount = 10) => {
            const additionalMedia = Array.from(
                { length: Math.max(0, maxCount - data.length) },
                (_, i) => ({
                    serialNo: data.length + i + 1,
                    value: 'https://assets.fevercdn.com/promotion/img/ugc_image/defaultImage.png'
                })
            );

            return [...data, ...additionalMedia];
        };

        const separateMediaList = (media, count) => {
            const firstHalfData = media.slice(0, count);
            const secondHalfData = media.slice(count);
            const firstHalfMediaList = autoFillFakeMedia(firstHalfData);
            const secondHalfMediaList = autoFillFakeMedia(secondHalfData);
            return { data: firstHalfMediaList, secondaryData: secondHalfMediaList };
        };

        // 應畫面 UI 需求，media 要分給上下兩層
        const middleIndex = Math.round(mediaList.length / 2);
        const media = separateMediaList(mediaList, middleIndex);
        return media;
    }

    function handleClick(serialNo) {
        if (serialNo) {
            window.open(
                `/ugc/${promoId}/${serialNo}${window.location.search}${window.location.hash}`
            );
        }
    }

    return (
        <>
            {!isInit && <Loading />}
            {Object.keys(marquee).length > 0 && (
                <MarqueeContainer
                    config={data.settingGame.galleryGameSetting}
                    clientBodyRef={clientBodyRef}
                    data={marquee}
                    buttonLink={buttonClickLink}
                    handleClick={handleClick}
                    needHandleClick
                    isInit={isInit}
                />
            )}
        </>
    );
}
